<template>
	<div class="fontS14 container mx-3">
		<h3 class="bold">¡Gracias por comprar en {{companyName}}!</h3>
		<p>Te enviaremos un correo electrónico y mensaje de texto cuando tu pedido esté en camino.</p>
		<p class="mb-4">Recuerda que si no podrás estar presente, deberás dejar a un tercero con el monto exacto a pagar.</p>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
	name: 'store-pick-up',
	computed: {
		...mapGetters([
			'companyName',
		]),
	},
};
</script>
<style lang="scss" scoped>
	.container {
		border-bottom: 0.1rem solid color(borderGrey);
	}
</style>




// WEBPACK FOOTER //
// storePickUp.vue?377cfe3e